<!-- 内容管理-新建/编辑 -->
<template>
  <div>
    <!-- *标题，*缩略图（图片上传），作者，*日期，*栏目，热门课程类型（栏目非热门课程-课程类型不显示，显示时必填），*简介，*内容uedit -->
    <el-card shadow="never"
             class="aui-card--fill">
      <el-form label-position="top"
               :model="dataForm"
               :rules="dataRule"
               ref="dataForm">
        <el-row class="row-mar-l">
          <!-- *标题 -->
          <el-col :span="12">
            <el-form-item :label="$t('content.contentTitle')"
                          prop="contentTitle"
                          style="width: 90% !important;">
              <el-input v-model="dataForm.contentTitle"
                        :placeholder="$t('content.contentTitle')">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <!-- 作者 -->
          <el-col :span="6">
            <el-form-item :label="$t('content.contentAuthor')"
                          prop="contentAuthor">
              <el-input v-model="dataForm.contentAuthor"
                        :placeholder="$t('content.contentAuthor')">
              </el-input>
            </el-form-item>
          </el-col>
          <!-- *日期 -->
          <el-col :span="6">
            <el-form-item :label="$t('content.contentDate')"
                          prop="contentDate">
              <el-date-picker v-model="dataForm.contentDate"
                              :placeholder="$t('content.contentDate')"
                              type="date"
                              value-format="yyyy-MM-dd 00:00:00"
                              :editable='false'>
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- *栏目 -->
          <el-col :span="6">
            <el-form-item :label="$t('content.contentColumn')"
                          prop="contentColumn">
              <el-select v-model="dataForm.contentColumn"
                         :placeholder="$t('content.contentColumn')"
                         clearable>
                <el-option v-for="(item,index) in contentColumnArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 热门课程类型 -->
          <el-col :span="6"
                  v-if="dataForm.contentColumn === '40'">
            <el-form-item :label="$t('content.contentType')"
                          prop="contentType">
              <el-select v-model="dataForm.contentType"
                         :placeholder="$t('content.contentType')"
                         clearable>
                <el-option v-for="(item,index) in contentTypeArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <!-- *缩略图 -->
          <el-col :span="18">
            <el-form-item :label="$t('content.imgUrlMsg')"
                          prop="contentImgUrl"
                          style="width: 90% !important;">
              <el-upload class="import-excel"
                         accept="image/png,image/jpg,image/jpeg"
                         :headers="myHeader"
                         :action="uploadUrl"
                         :show-file-list="false"
                         :multiple="false"
                         :on-success="handleSuccess"
                         :before-upload="beforeExcelUpload"
                         :on-error="handleError"
                         :file-list="fileList"
                         v-model="dataForm.contentImgUrl">
                <el-input v-model="fileName"
                          :disabled="true"
                          class="import-excel-input">
                </el-input>
                <el-button slot="trigger"
                           type="primary"
                           icon="el-icon-upload2">上传文件
                </el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l"
                v-if="dataForm.contentColumn === '10'">
          <!-- 视频 -->
          <el-col :span="18">
            <el-form-item :label="$t('content.videoUrl')"
                          prop="videoUrl"
                          style="width: 90% !important;">
              <el-upload class="import-excel"
                         accept=".mp4, .mov"
                         :headers="myHeader"
                         :action="uploadUrl"
                         :show-file-list="false"
                         :multiple="false"
                         :on-success="handleSuccessVideo"
                         :before-upload="beforeExcelUploadVideo"
                         :on-error="handleErrorVideo"
                         :file-list="fileListVideo"
                         v-model="dataForm.videoUrl">
                <el-input v-model="fileNameVideo"
                          :disabled="true"
                          class="import-excel-input">
                </el-input>
                <el-button slot="trigger"
                           type="primary"
                           icon="el-icon-upload2">上传文件
                </el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <!-- *简介 -->
          <el-col :span="24">
            <el-form-item :label="$t('content.description')"
                          prop="description"
                          style="width: 95% !important;">
              <el-input v-model="dataForm.description"
                        type="textarea"
                        :autosize="{ minRows: 3}"
                        :placeholder="$t('content.description')"
                        maxlength="100"
                        show-word-limit>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-2">
          <el-form-item :label="$t('content.publishContent')"
                        prop="publishContent"
                        style="width: 95% !important;">
          </el-form-item>
        </el-row>
      </el-form>
      <div class="content">
        <vue-ueditor-wrap @ready="ready"
                          :destroy="true"
                          v-model="dataForm.publishContent"
                          :config="myConfig"></vue-ueditor-wrap>
      </div>
      <div class="btn-position-up">
        <el-button type="primary"
                   @click="dataFormSubmitHandle()">{{ $t('organization.save') }}</el-button>
        <el-button @click="backPage()">{{ $t('organization.back') }}</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import axios from 'axios'

export default {
  data() {
    return {
      contentColumnArr: this.enums['contentColumn'],
      contentTypeArr: this.enums['content_type'],
      fileList: [],
      fileName: '',
      fileListVideo: [],
      fileNameVideo: '',
      url: '/sys/config/imgUpload',
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 800,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口
        serverUrl: window.SITE_CONFIG['apiURL'] + '/sys/config/imgUpload' + `?token=${this.getStorage(this.GLOBAL.TOKEN)}`,
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况
        UEDITOR_HOME_URL: '/UEditor/'
      },
      dataForm: {
        contentTitle: '',
        contentImgUrl: '',
        contentAuthor: '',
        contentDate: '',
        contentColumn: '',
        contentType: '',
        description: '',
        publishContent: ''
      },
      emptyForm: {
        contentTitle: '',
        contentImgUrl: '',
        contentAuthor: '',
        contentDate: '',
        contentColumn: '',
        contentType: '',
        description: '',
        publishContent: ''
      },
      myHeader: { token: '' }, // token
      ueditorExamples: {}
    }
  },
  computed: {
    dataRule() {
      return {
        contentTitle: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { max: 100, message: this.$t('validate.validateLength', { 'handle': '100' }), trigger: 'blur' }
        ],
        contentImgUrl: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        contentAuthor: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { max: 20, message: this.$t('validate.validateLength', { 'handle': '20' }), trigger: 'blur' }
        ],
        contentDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        contentColumn: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        contentType: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        description: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // this.uploadUrl = `${window.SITE_CONFIG['apiURL']}` + this.url + `?token=${this.getStorage(this.GLOBAL.TOKEN)}`
    axios.post(this.uploadUrl = `${window.SITE_CONFIG['apiURL']}` + this.url)
    this.myHeader.token = this.getStorage(this.GLOBAL.TOKEN)
    this.$eventHub.$on(this.GLOBAL.ACTIVATED_CONTENT, (data) => {
      this.dataForm = this.emptyForm
      this.fileName = ''
      this.fileList = []
      this.fileNameVideo = ''
      this.fileListVideo = []
      if (this.$refs.dataForm) {
        this.$refs['dataForm'].resetFields()
        this.initialization()
      }
    })
  },
  mounted() {
    this.initialization()
  },
  methods: {
    ready(editorInstance) {
      // console.log(`编辑器实例${editorInstance.key}: `, editorInstance)
      this.ueditorExamples = editorInstance
    },
    initialization() {
      if (this.$route.query.id) {
        this.dataForm.id = this.$route.query.id
        this.getInfo()
      }
    },
    getInfo() {
      this.$request.get(`/sys/commcontent/info/${this.dataForm.id}`).then((res, total, code, data) => {
        this.fileName = res.contentImgUrl.match(/\/img\/(.*)/)[1]
        if (res.videoUrl) {
          this.fileNameVideo = res.videoUrl.match(/\/img\/(.*)/)[1]
        }
        this.dataForm = {
          ...this.dataForm,
          ...res
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        if (this.ueditorExamples.getContentLength(true) > 10000) {
          this.$alert('内容不能超过一万个字符')
          return false
        }
        if (!this.dataForm.publishContent || this.dataForm.publishContent === '') {
          this.$alert('内容不能为空').then()
          return false
        }
        this.$request.post(`/sys/commcontent/${!this.dataForm.id ? 'save' : 'update'}`,
          this.dataForm
        ).then((res, total, code, data) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.tabRemove(this.$store.state.contentTabsActiveName)
            }
          })
        }).catch((err) => {
          console.log(err)
        })
      })
    }, 1000, { 'leading': true, 'trailing': false }),

    // response接口返回值的全部 response.result为需要回显的文件存放位置
    handleSuccess(response, file, fileList) {
      if (Number(fileList[0].response.code) < 0) {
        this.$alert(fileList[0].response.msg)
        this.fileName = ''
        this.fileList = []
        return 0
      }
      this.dataForm.contentImgUrl = response.data
      this.fileName = file.name
      this.$message({
        message: '上传成功',
        type: 'success',
        duration: 1500
      })
    },
    handleSuccessVideo(response, file, fileList) {
      if (Number(fileList[0].response.code) < 0) {
        this.$alert(fileList[0].response.msg)
        this.fileNameVideo = ''
        this.fileListVideo = []
        return 0
      }
      this.dataForm.videoUrl = response.data
      this.fileNameVideo = file.name
      this.$message({
        message: '上传成功',
        type: 'success',
        duration: 1500
      })
    },
    beforeExcelUpload(file) {
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg');
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$alert('上传缩略图只能是 jpeg，jpg 或者 png 格式!');
      }
      if (!isLt2M) {
        this.$alert('上传缩略图大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    beforeExcelUploadVideo(file) {
      console.warn(file.type)
      const isJPG = (file.type === 'video/mp4' || file.type === 'video/quicktime');
      const isLt2M = file.size / 1024 / 1024 < 500;
      if (!isJPG) {
        this.$alert('上传视频只能是 mp4 或者 mov 格式!');
      }
      if (!isLt2M) {
        this.$alert('上传视频大小不能超过 500MB!');
      }
      return isJPG && isLt2M;
    },
    handleError(err, file, fileList) {
      console.log(err);
    },
    handleErrorVideo(err, file, fileList) {
      console.log(err)
    },
    backPage() {
      this.$router.push({
        name: 'sys-content'
      })
    },
    // 删除窗口
    tabRemove(tabName) {
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          name: 'sys-content'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.row-mar-l {
  margin-left: 22px;
  margin-bottom: 10px;
}
.row-mar-2 {
  margin-left: 22px;
  margin-bottom: 0px;
}
.content {
  max-width: 93.5%;
  margin-left: 22px;
}
.import-excel {
  .import-excel-input {
    width: 65% !important;
    float: left;
    margin-right: 20px;
  }
}
.el-upload {
  width: 100% !important;
}
.import-excel .import-excel-input .el-input__inner {
  color: black;
}
 .el-textarea .el-input__count {
  bottom: -26px !important;
}
</style>
